import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useAnalyticsContext } from '../../../../config/GoogleTagManagerEvents';
import { VARIABLE_CONFIG } from '../../../../constants/analyticsConstants/Variables';
import { useDidMount } from '../../../../hooks/useDidMount';
import useMedia from '../../../../hooks/useMedia';
import { usePageType } from '../../../../hooks/usePageType';
import ChevronDownGreen from '../../../../resources/images/chevron-down-green.svg';
import Plus from '../../../../resources/images/plus16.svg';
import Button from '../../atoms/button/button';
import Checkbox from '../../atoms/Checkbox/Checkbox';
import { logError } from '../../utils/logger';
import { ENV_CONFIG } from '../../../../constants/envConfig';
import './filters.scss';
import { FACET_TYPES } from '../../../search/hooks/useSearchUtils';

const FilterBody = props => {
    const {
        filterData = {},
        setFilterData,
        data,
        filterBodyClasess,
        toggleSelect,
        showMoreLimit,
        clearAll,
        setIsClearAll,
        isShowMoreVisible,
        onShowMoreClick,
        triggerEvents
    } = props;
    const mediaType = useMedia();
    const didMount = useDidMount();
    const intl = useIntl();
    const pageType = usePageType();
    const { sendEventsForClick } = useAnalyticsContext();

    const renderOption = (optionName, filterName, numberOfResults, optionType, optionValues) => {
        const currntFilters = filterData[filterName];
        const isChecked = currntFilters?.selectedOptions?.includes(optionName);
        var localFilterData = { ...filterData };
        const handleCheck = (label, currentVal) => {
            if (triggerEvents) {
                try {
                    sendEventsForClick(
                        VARIABLE_CONFIG.EVENT.UAEVENT,
                        VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                        `filter ${pageType}`,
                        VARIABLE_CONFIG.EVENT_ACTION.SELECT,
                        `subcategory::${label}`
                    );
                } catch (error) {
                    logError(error, false, 'handleCheck');
                }
            }
            if (optionType !== FACET_TYPES.NUMERIC_RANGE) {
                toggleSelect(optionName);
            } else {
                toggleSelect(optionValues);
            }
            //opposite condition because state is not set yet
            if (currentVal) {
                if (!isChecked) {
                    localFilterData[filterName].selectedOptions.push(optionName);
                }
            } else {
                if (isChecked) {
                    localFilterData[filterName].selectedOptions = localFilterData[filterName].selectedOptions.filter(
                        item => item !== optionName
                    );
                }
            }
            setFilterData(localFilterData);
        };

        return (
            <>
                <div
                    className={`filter__item-option ${filterName} ${optionName} ${isChecked && 'selectedOptionBackground'
                        }`}>
                    <Checkbox
                        label={`${optionName} ${numberOfResults > 0 ? `(${numberOfResults})` : '(0)'}`}
                        onClick={handleCheck}
                        isChecked={isChecked}
                        customClassName={`${optionName}`}
                        tabIndex={0}
                    />
                </div>
            </>
        );
    };
    const constructOptionBody = filterName => {
        const filterOptions = data[filterName].choices;
        return filterOptions.map((option, index) => {
            if (option?.numberOfResults && option?.numberOfResults > 0) {
                if (option.type === FACET_TYPES.NUMERIC_RANGE) {
                    if (option.values.start === 0 && option.values.end === 0) {
                        return null;
                    } else
                        return (
                            <div key={option.name}>
                                {renderOption(
                                    option.name,
                                    filterName,
                                    option.numberOfResults,
                                    option.type,
                                    option.values
                                )}
                            </div>
                        );
                } else {
                    return (
                        <div key={option.name}>
                            {renderOption(option.name, filterName, option.numberOfResults, option.type, option.values)}
                        </div>
                    );
                }
            }
        });
    };

    const renderFilterOption = (filterName, title) => {

        const [isListVisible, setIsListVisible] = useState(ENV_CONFIG.META_FACETS_STATE);
        const calcSuffix = () => {
            return filterData[filterName]?.selectedOptions?.length || 0;
        };
        const handleFilterNameClick = title => {
            setIsListVisible(!isListVisible);
            if (triggerEvents) {
                try {
                    sendEventsForClick(
                        VARIABLE_CONFIG.EVENT.UAEVENT,
                        VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                        `filter ${pageType}`,
                        VARIABLE_CONFIG.EVENT_ACTION.SELECT,
                        `subcategory::${title.toLowerCase()}`
                    );
                } catch (error) {
                    logError(error, false, 'handleFilterNameClick');
                }
            }
        };
        return (
            <React.Fragment key={title}>
                <div className={`filter__item ${isListVisible ? 'filter__item--open' : ''}`}>
                    <div className={`filter__title`} onClick={() => handleFilterNameClick(title)}>
                        {`${title} ${calcSuffix() > 0 ? `(${calcSuffix()})` : ''}`}

                        <button
                        aria-expanded={isListVisible}
                            className={`filter__title-expend ${isListVisible && 'expandedList'}`}
                            aria-label={
                                isListVisible
                                    ? `${title} ${intl.formatMessage({ id: 'filter:expanded-filter' })} `
                                    : `${title} ${intl.formatMessage({ id: 'filter:collapsed-filter' })} `
                            }
                            tabIndex={0}>
                            <ChevronDownGreen />
                        </button>
                    </div>
                    <div
                        className={`filter__item-body ${filterName} ${isListVisible ? 'filter__item-body--open' : ''}`}>
                        {constructOptionBody(filterName)}
                        {isShowMoreVisible && (
                            <Button
                                type="button"
                                onClick={() => onShowMoreClick()}
                                dataTestid='filter-item-show-more-cta'
                                buttonAriaLabel={`${intl.formatMessage({ id: 'location:show-more-cta' })}`}
                                className="filter__item-button">
                                {'Show more'}
                                <Plus />
                            </Button>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    };
    const constructBody = () => {
        let filterOptions = [];
        for (let filter in data) {
            filterOptions.push(renderFilterOption(filter, data[filter].title));
        }
        return filterOptions;
    };
    return (
        <>
            <div className={`filter__body-topfilters`}></div>
            {constructBody()}
        </>
    );
};

export default FilterBody;
